<template>
  <div>
    <div class="preloader">
      <div class="preloader-content">
        <svg
          width="120"
          height="144"
          viewBox="0 0 60 77"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.3486 53.5315H26.1702C24.7954 53.5315 23.8134 54.6952 24.0098 56.0529H29.9018C31.6694 54.3073 33.6334 52.9496 35.7938 51.9799C35.2046 49.6524 34.8118 47.131 35.0082 44.8035C33.2406 44.9975 31.6694 45.1914 29.9018 45.7733C29.3126 45.9673 29.1162 46.3552 29.3126 46.937C29.9018 48.2947 30.491 49.6524 31.0802 51.0101C29.9018 51.7859 28.9198 52.5617 27.9378 53.5315C27.7414 53.5315 27.545 53.5315 27.3486 53.5315ZM43.0606 30.4509C42.6678 31.2267 42.6678 32.1965 43.4534 32.9723C45.0246 34.33 46.7921 35.1058 47.7741 37.0453C48.3633 38.0151 49.1489 39.9547 47.3813 40.1486C45.8102 40.3426 43.4534 38.7909 42.0786 37.8212C42.6678 38.597 42.8642 39.5668 43.257 40.3426C43.4534 40.7305 43.6498 40.9244 43.8462 40.9244C45.4173 41.7003 47.9705 42.2821 49.1489 40.7305C50.3273 39.3728 49.9345 37.6272 48.7561 36.0756C47.5777 34.136 45.6138 33.5542 44.239 32.0025C44.0426 31.8086 43.8462 31.4207 44.0426 31.2267C44.239 30.6448 44.8282 30.4509 45.4174 30.4509C46.2029 30.2569 47.1849 30.063 47.7741 29.869C48.3633 29.4811 48.5597 28.8992 48.7561 28.5113L48.9525 27.5416C47.5777 27.9295 46.0065 28.3174 44.8282 28.8992C44.4354 29.2872 43.4534 29.869 43.0606 30.4509ZM22.8314 22.3048C25.3846 17.8438 28.3306 13.5768 31.473 9.50378C32.0622 7.56423 31.6694 6.01259 30.8838 4.46096L29.3126 0.969773C25.9738 6.4005 23.0278 12.0252 20.4746 17.8438C20.0818 18.6196 20.2782 19.5894 20.8674 20.1713C21.4566 20.7531 22.2422 21.529 22.8314 22.3048ZM13.6007 56.0529C18.707 48.8766 26.9558 44.2217 35.7938 43.8338C36.5794 46.3552 37.9542 48.6826 39.5254 50.8161C42.4714 50.2343 45.4174 50.4282 48.1669 51.204L48.9525 53.1436C48.9525 53.3375 48.9525 53.5315 48.7561 53.5315H47.9705C46.5957 53.5315 45.6137 54.6952 45.8101 56.0529H51.3093C52.0949 56.0529 52.6841 55.2771 52.4877 54.5013L50.1309 48.4887C48.5597 47.9068 46.9885 47.7128 45.4174 47.5189L42.0786 38.9849C41.4894 37.4333 39.5254 36.6574 38.1506 36.2695C36.5794 35.8816 34.6154 35.6877 32.8478 35.8816C34.8118 34.9118 36.7758 33.9421 38.9362 33.1662C40.1146 32.7783 40.9002 31.8086 41.293 30.8388C41.6858 29.869 41.8822 29.0932 42.275 28.1234C40.5074 28.8992 38.7398 29.6751 36.9722 30.6448C38.1506 29.869 39.329 29.0932 40.5074 28.3174C42.0786 27.3476 42.8642 26.3778 43.257 24.8262C43.4534 23.6625 43.6498 22.6927 43.8462 21.529C41.6858 22.3048 39.329 23.4685 37.365 24.4383C38.347 23.6625 39.9182 22.6927 40.9002 22.1108C43.0606 20.7531 44.239 18.6196 44.4354 16.0982C44.4354 14.9345 44.4354 13.7708 44.4354 12.801C41.4894 14.5466 38.5434 16.2922 35.7938 18.4257C37.365 16.8741 38.9362 15.3224 40.7038 13.9647C43.257 11.6373 44.239 8.53401 43.6498 5.23678C43.257 3.49118 42.8642 1.74559 42.275 0C38.9362 3.10327 35.7938 6.59446 32.8478 10.0856C29.7054 13.9647 26.7594 18.2317 24.0098 22.4987C23.617 23.2746 23.617 24.0504 24.0098 24.6322C24.9918 25.9899 25.9738 27.5416 26.3666 29.0932C27.545 33.5542 25.1882 34.9118 22.8314 36.6574C22.2422 37.0453 22.2422 36.6574 22.4386 36.4635C22.635 36.2695 22.8314 36.0756 23.0278 35.8816C24.7954 34.33 24.9918 31.4207 23.8134 29.2872C22.2422 26.5718 20.0818 24.0504 17.5286 22.1108C17.1358 23.0806 16.5466 24.0504 14.9755 25.0202C13.9935 25.602 11.8331 27.1537 10.0655 29.6751C10.8511 30.8388 11.6367 31.6146 12.8151 32.3904C13.2079 32.0025 13.6007 31.6146 14.1899 31.2267C14.5827 30.8388 15.1719 31.0327 15.3682 31.4207C15.761 31.0327 15.761 31.6146 15.3682 32.0025L14.9755 32.3904C14.5827 32.7783 13.9935 32.5844 13.7971 32.1965C13.7971 32.1965 13.7971 32.0025 13.6007 32.0025L13.2079 32.3904C13.6007 33.1662 14.1899 34.5239 14.3863 34.5239C14.5827 34.5239 14.5827 34.5239 14.7791 34.33L16.3502 32.9723C16.3502 32.7783 16.5466 32.9723 16.5466 33.1662C14.9754 36.0756 13.2079 39.5667 12.2259 42.67C12.0295 43.2519 12.2259 43.8338 12.4223 44.2217C13.2079 45.5793 14.5827 46.937 14.9755 47.3249C13.6007 49.0705 12.4223 51.0101 11.4403 52.9496C11.2439 53.3375 10.8511 53.5315 10.2619 53.5315H8.69067C7.31588 53.5315 6.33388 54.6952 6.53028 56.0529H13.6007ZM29.509 63.6171H25.581L19.689 69.2418V63.6171H16.5466V76.6121H19.689V73.1209L21.8494 71.1814L25.7774 76.806H29.9018L24.4026 69.0479L29.509 63.6171ZM45.221 63.6171H41.293L35.401 69.2418V63.6171H32.2586V76.6121H35.401V73.1209L37.5614 71.1814L41.4894 76.806H45.6138L40.1146 69.0479L45.221 63.6171ZM10.2619 63.6171C9.27987 63.4232 8.10147 63.2292 7.11948 63.2292C6.13748 63.2292 4.95908 63.4232 3.97709 63.6171C2.20949 64.005 0.834697 65.3627 0.441899 67.1083C-0.1473 69.2418 -0.1473 71.1814 0.441899 73.3149C0.834697 75.0604 2.20949 76.4181 3.97709 76.806C4.95908 76.806 6.13748 77 7.11948 77C8.10147 77 9.27987 76.806 10.2619 76.6121C12.0295 76.2242 13.4043 74.8665 13.7971 73.1209C14.3863 70.9874 14.3863 69.0479 13.7971 66.9144C13.4043 65.3627 12.0295 64.005 10.2619 63.6171ZM10.8511 72.3451C10.6547 72.9269 10.2619 73.5088 9.47627 73.5088C7.90507 73.8967 6.33388 73.8967 4.56629 73.5088C3.97709 73.3149 3.38789 72.9269 3.19149 72.3451C2.79869 70.7934 2.79869 69.2418 3.19149 67.6902C3.38789 67.1083 3.78069 66.5264 4.56629 66.5264C6.13748 66.1385 7.70868 66.1385 9.47627 66.5264C10.0655 66.7204 10.6547 67.1083 10.8511 67.6902C11.2439 69.2418 11.2439 70.7934 10.8511 72.3451ZM59.5581 66.9144C59.1653 65.1688 57.7905 63.8111 56.0229 63.4232C55.0409 63.2292 53.8625 63.0353 52.8805 63.0353C51.8985 63.0353 50.7201 63.2292 49.7381 63.4232C47.9705 63.8111 46.5957 65.1688 46.2029 66.9144C45.6138 69.0479 45.6138 70.9874 46.2029 73.1209C46.5957 74.8665 47.9705 76.2242 49.7381 76.6121C50.7201 76.806 51.8985 77 52.8805 77C53.8625 77 55.0409 76.806 56.0229 76.6121C57.7905 76.2242 59.1653 74.8665 59.5581 73.1209C60.1473 71.1814 60.1473 69.0479 59.5581 66.9144ZM56.6121 72.3451C56.4157 72.9269 56.0229 73.5088 55.2373 73.5088C53.6661 73.8967 52.0949 73.8967 50.3273 73.5088C49.7381 73.3149 49.1489 72.9269 48.9525 72.3451C48.5597 70.7934 48.5597 69.2418 48.9525 67.6902C49.1489 67.1083 49.5417 66.5264 50.3273 66.5264C51.8985 66.1385 53.4697 66.1385 55.2373 66.5264C55.8265 66.7204 56.4157 67.1083 56.6121 67.6902C57.0049 69.2418 57.0049 70.7934 56.6121 72.3451Z"
            fill="#FEEA01"
          />
        </svg>
        <h1>ФАКТИ ПРО АРКТИКУ</h1>
        <div class="timer">
          <div class="fill" :style="timerStyle"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      time: {
        type: Number,
        default: 1000
      }
    },
    data() {
      return {
        timerStyle: {
          animationDuration: `${this.time / 1000}s`
        }
      };
    }
  };
</script>

<style lang="scss" scoped>
  .preloader {
    position: fixed;
    width: 100%;
    height: 100%;
    background: #040913;
    &-content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      max-width: 500px;
      width: 100%;
      height: 350px;
      text-align: center;
      h1 {
        color: #feea01;
        font-weight: 800;
        font-size: 40px;
        line-height: 50px;
      }
    }
  }
  .timer {
    width: 281px;
    margin: 10px auto;
    border-radius: 3px;
    height: 5px;
    background: #494949;
    position: relative;
    overflow: hidden;
    .fill {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: white;
      transform-origin: left;
      animation: load 1 1s ease-in-out both;
    }
  }
  @keyframes load {
    from {
      transform: scaleX(0);
    }
    to {
      transform: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Preloader.vue